/* @flow */
import { API_URL } from '../../Constants';
import type { PartnerID, PartnerSessionInfo } from '../../data/Partners';

export function getPartnerSessionInfo(partnerId: PartnerID, sessionId: string) {
  return {
    url: `${API_URL}/partners/${partnerId}/sessions/${sessionId}`,
    options: {
      method: 'GET',
    },
    transform: (response: PartnerSessionInfo) => ({
      partnerSessionInfo: response,
      locationsById: response.destination,
      locationsByGooglePlaceId: response.destination,
    }),
    update: {
      partnerSessionInfo: (
        prevPartnerSessionInfo: ?PartnerSessionInfo,
        newPartnerSessionInfo: PartnerSessionInfo
      ) => newPartnerSessionInfo,
      locationsById: (prevLocations: Object, location: Object) => ({
        ...prevLocations,
        [location.id]: location,
      }),
      locationsByGooglePlaceId: (prevLocations: Object, location: Object) => ({
        ...prevLocations,
        [location.google_place_id]: location,
      }),
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/partners/queries.js